import React from 'react';
import { motion } from 'framer-motion';
const BEDROOM_IMAGE = 'https://cdn.magicpatterns.com/uploads/eL3cZCxFqXPzZ1PcKNsJiB/HABITACION.webp';
const MARBLE_IMAGE = 'https://cdn.magicpatterns.com/uploads/2hvUvmPnBN6RhWzKhVUQoE/marmoldetalle.webp';
const ALLY_ACTION_IMAGE = 'https://cdn.magicpatterns.com/uploads/rEuFAQBpHwaGaXi9t8csCF/allylimpiando.webp';
interface GalleryImageProps {
  src: string;
  alt: string;
  caption?: string;
  className: string;
  delay: number;
  aspectClass?: string;
  imageClass?: string;
}
const PENTHOUSE_LIGHTING_IMAGE = 'https://cdn.magicpatterns.com/uploads/adKBfCnkHpuYXGGvgA8Rvq/Limpieza1.webp';
const PENTHOUSE_KITCHEN_IMAGE = 'https://cdn.magicpatterns.com/uploads/9fsJ8EaZnZC28qPzhcRimo/Limpieza2.webp';
export function ExcellenceGallery() {
  return <section aria-labelledby="excellence-heading" className="w-full bg-white" data-id="element-36" data-mp="1b099521got1k">
      <div className="mx-auto max-w-7xl px-5 pb-12 pt-16 sm:px-8 sm:py-32" data-id="element-37" data-mp="1604ttfcai4cx">
        <div className="grid gap-8 sm:gap-12 lg:grid-cols-12 lg:items-start lg:gap-16" data-id="element-38" data-mp="2f14s09mbz20p">
          <motion.div initial={{
          opacity: 0,
          x: -24
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.55
        }} className="lg:col-span-4 lg:sticky lg:top-28" data-id="element-39" data-mp="2f3hixca2gmpw">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-magenta" data-id="element-40" data-mp="2a2aadb03nji6">
              The Ally Difference
            </p>
            <p className="mt-4 font-display text-sm font-semibold uppercase tracking-[0.18em] text-slate-muted sm:mt-5" data-id="element-41" data-mp="32qfwa12w3ejl">
              The Standard of Excellence
            </p>
            <h2 id="excellence-heading" className="mt-4 font-display text-4xl font-extrabold leading-[1.08] tracking-tight text-slate sm:text-5xl" data-id="element-42" data-mp="2nzyu2fifkkln">
              More Than Cleaning. A Lifestyle of Care.
            </h2>
            <div className="mt-6 h-px w-16 bg-magenta sm:mt-7" data-id="element-43" data-mp="3lhyvdwtsm8gc" />
            <p className="mt-6 max-w-md text-base leading-relaxed text-slate-soft sm:mt-7" data-id="element-44" data-mp="3vdpc8sfl3bgb">
              We understand that luxury isn&apos;t just about the surface—it&apos;s about the
              peace of mind that comes from knowing every corner of your home is handled
              with absolute precision. Our methods are designed for New York&apos;s high-end
              materials, from delicate Italian marble to premium upholstery. We don&apos;t
              just clean; we preserve the value and beauty of your sanctuary. Every visit
              follows our 50-point perfection checklist to ensure that when you walk
              through your door, the only thing you feel is relief.
            </p>
          </motion.div>

          <div className="grid grid-cols-2 gap-4 sm:gap-5 lg:col-span-8 lg:grid-cols-4" data-id="element-45" data-mp="2yohrhmmsh6dg">
            <GalleryImage src={BEDROOM_IMAGE} alt="Immaculately made luxury bedroom with crisp white linens and city views" caption="Restful Sanctuaries" className="col-span-2" aspectClass="aspect-[16/9]" delay={0.05} data-id="element-46" data-mp="2tmioiduyobh1" />
            <GalleryImage src={MARBLE_IMAGE} alt="A gloved hand carefully cleaning a polished marble countertop" caption="Specialized Surface Care" className="col-span-1" aspectClass="aspect-square" delay={0.12} data-id="element-47" data-mp="193ydes4v2470" />
            <GalleryImage src={ALLY_ACTION_IMAGE} alt="Ally carefully cleaning a high-end New York apartment interior" caption="The Meticulous Touch" className="col-span-1 row-span-2" aspectClass="aspect-[9/16]" imageClass="object-top" delay={0.19} data-id="element-48" data-mp="le424f06wnov" />
            <GalleryImage src={PENTHOUSE_LIGHTING_IMAGE} alt="Ally meticulously cleaning a pendant light in a bright penthouse kitchen" className="col-span-1" aspectClass="aspect-square" delay={0.26} data-id="element-49" data-mp="2oo17qklet7x" />
            <GalleryImage src={PENTHOUSE_KITCHEN_IMAGE} alt="Ally carefully cleaning a statement chandelier in a luxury kitchen" className="col-span-1" aspectClass="aspect-square" delay={0.33} data-id="element-50" data-mp="3ets03o9q6l1l" />
          </div>
        </div>
      </div>
    </section>;
}
function GalleryImage({
  src,
  alt,
  caption,
  className,
  delay,
  aspectClass = 'aspect-[4/3]',
  imageClass = ''
}: GalleryImageProps) {
  return <motion.figure initial={{
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-70px'
  }} transition={{
    duration: 0.5,
    delay
  }} className={className} data-id="element-51" data-mp="gbwh6nj58ipt">
      <div className={`overflow-hidden rounded-2xl bg-slate-100 ${aspectClass}`} data-id="element-52" data-mp="2i3j001svt7b7">
        <img src={src} alt={alt} className={`h-full w-full object-cover ${imageClass}`} data-id="element-53" data-mp="2d4eubl561rpm" />
      </div>
      {caption && <figcaption className="mt-4 font-display text-base font-bold tracking-tight text-slate" data-id="element-54" data-mp="snymqg91yhfc">
          {caption}
        </figcaption>}
    </motion.figure>;
}